export default __webpack_public_path__ + "static/media/hht1_ep05_timeline_q01_a.b85a5707.png";